import { useEffect, useState } from "react";
import { OnboardingWalkthrough } from "./OnboardingWalkthrough";
import { ONBOARDING_OPEN_EVENT } from "@/lib/onboarding/state";
import { useAuth } from "@/lib/auth";

/**
 * Mounts onboarding once the user has an authenticated session.
 *
 * The forced first-run "Setup" walkthrough (Settings → Location → Photos,
 * continue prompt, extended tour) has been removed. Only the explicit
 * "Replay walkthrough" trigger from Settings still opens a tutorial.
 */
export function OnboardingProvider() {
  const { session } = useAuth();
  const [replayOpen, setReplayOpen] = useState(false);

  useEffect(() => {
    const handler = () => setReplayOpen(true);
    window.addEventListener(ONBOARDING_OPEN_EVENT, handler);
    return () => window.removeEventListener(ONBOARDING_OPEN_EVENT, handler);
  }, []);

  if (!session) return null;
  if (replayOpen) {
    return <OnboardingWalkthrough onClose={() => setReplayOpen(false)} />;
  }
  return null;
}
